import { request } from '@/fetch/core';
import { Method } from '@/fetch/core/constant';
import {
  ImportRecordPage,
  ProvinceAgency,
  ProvinceTargetUploadResult,
} from '@/views/BusinessTargetConfig/types';
import { ApiResponse } from '@/types';

const BIZ_TYPE = 2;

export interface ImportRecordPageParams {
  pageNum: number;
  pageSize: number;
  startModifyTime?: string;
  endModifyTime?: string;
}

export interface ProvinceTargetUploadParams {
  fileName?: string;
  rows: Array<{
    targetYear: string;
    targetMonth: string;
    provinceAgencyCode: string;
    provinceAgencyName: string;
    unmannedVehicleCount: string;
    dailyConnectOrder: string;
    dailyConnectTrip: string;
  }>;
}

const post = <T>(path: string, body?: Record<string, unknown>): Promise<ApiResponse<T>> => {
  return request({ path, method: Method.POST, body }) as Promise<ApiResponse<T>>;
};

export const businessTargetConfigApi = {
  getProvinceAgencyList: () => post<ProvinceAgency[]>('/k2/management/common/get_province_agency_list', {}),

  getTemplateUrl: () => post<{ url: string }>('/k2/management/common/upload/import/template_url', { bizType: BIZ_TYPE }),

  uploadProvinceTarget: (params: ProvinceTargetUploadParams) =>
    post<ProvinceTargetUploadResult>('/k2/management/common/province_target/upload', params),

  getImportRecords: (params: ImportRecordPageParams) =>
    post<ImportRecordPage>('/k2/management/common/upload/import/page', { ...params, bizType: BIZ_TYPE }),

  getSuccessDetailUrl: (taskNo: string) =>
    post<{ url: string }>('/k2/management/common/upload/import/download', { taskNo, success: 1 }),
};
